export const SVA_ROUTES = [
  '/sva/insurances/home',
  '/sva/insurances/offers',
  '/sva/insurances/store-self-hiring',
  '/sva/insurances/life-self-hiring',
  '/sva/insurances/transaction-self-hiring',
  '/sva/insurances/details',
  '/sva/insurances/charge-history',
  '/sva/insurances/beneficiaries',
  '/sva/insurances/cancellation'
] as const
